import {
  AdvisorCoachingResponse,
  CoachingMetricsListResponse,
  TServerErrorResponse,
} from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const COACHING_GET = "coaching-get";
export const COACHING_METRICS_GET = "coaching-metrics-get";
export const CUSTOMER_ADMIN_COACHING_GET = "customer-admin-coaching-get";

export const getCoachingByConversationId = async (
  conversationId: string,
): Promise<AdvisorCoachingResponse | null> => {
  if (!conversationId) return null;
  try {
    const response = await http.get<AdvisorCoachingResponse>(
      links.coaching.byConversationId(conversationId),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export interface CoachingMetricsParams {
  startDate?: number;
  endDate?: number;
  take?: number;
  skip?: number;
  asc?: boolean;
}

export interface CustomerAdminCoachingParams extends CoachingMetricsParams {
  userIds?: string[];
}

/**
 * Get coaching metrics for the current user
 */
export const getCoachingMetrics = async (
  params?: CoachingMetricsParams,
): Promise<CoachingMetricsListResponse> => {
  try {
    const queryParams = new URLSearchParams();

    if (params?.startDate) {
      queryParams.append("startDate", params.startDate.toString());
    }
    if (params?.endDate) {
      queryParams.append("endDate", params.endDate.toString());
    }
    if (params?.take) {
      queryParams.append("take", params.take.toString());
    }
    if (params?.skip) {
      queryParams.append("skip", params.skip.toString());
    }
    if (params?.asc !== undefined) {
      queryParams.append("asc", params.asc.toString());
    }

    const queryString = queryParams.toString();
    const url = queryString
      ? `${links.coaching.metrics}?${queryString}`
      : links.coaching.metrics;

    const response = await http.get<CoachingMetricsListResponse>(url);
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

/**
 * Get coaching metrics for all users in the firm (admin only)
 */
export const getCustomerAdminCoaching = async (
  params?: CustomerAdminCoachingParams,
): Promise<CoachingMetricsListResponse> => {
  try {
    const queryParams = new URLSearchParams();

    if (params?.userIds && params.userIds.length > 0) {
      params.userIds.forEach((id) => queryParams.append("userIds", id));
    }
    if (params?.startDate) {
      queryParams.append("startDate", params.startDate.toString());
    }
    if (params?.endDate) {
      queryParams.append("endDate", params.endDate.toString());
    }
    if (params?.take) {
      queryParams.append("take", params.take.toString());
    }
    if (params?.skip) {
      queryParams.append("skip", params.skip.toString());
    }
    if (params?.asc !== undefined) {
      queryParams.append("asc", params.asc.toString());
    }

    const queryString = queryParams.toString();
    const url = queryString
      ? `${links.customerAdmin.coaching}?${queryString}`
      : links.customerAdmin.coaching;

    const response = await http.get<CoachingMetricsListResponse>(url);
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
